
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AdvocacyHeroSection from './components/AdvocacyHeroSection';
import PolicyInitiativesSection from './components/PolicyInitiativesSection';
import LegislativeWinsSection from './components/LegislativeWinsSection';
import ActiveCampaignsSection from './components/ActiveCampaignsSection';
import GetInvolvedSection from './components/GetInvolvedSection';
import ResourcesSection from './components/ResourcesSection';
import AdvocacyCTASection from './components/AdvocacyCTASection';

export default function Advocacy() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AdvocacyHeroSection />
        <PolicyInitiativesSection />
        <LegislativeWinsSection />
        <ActiveCampaignsSection />
        <GetInvolvedSection />
        <ResourcesSection />
        <AdvocacyCTASection />
      </main>
      <Footer />
    </div>
  );
}
